import React from "react";
import HeaderBlog from "../templates/blog/HeaderBlog.jsx";
import Footer from "../templates/Footer";

const LayoutBlog = (props) => {
	return (
		<>
			<HeaderBlog />
			{props.children}
			{!props.dontFooter&&<Footer />}
		</>
	);
};

export default LayoutBlog;
